<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">
          Solicitação de marcação
        </div>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-4">
            <label><span class="required">*</span> Data</label>
            <input
              v-model="checkRequest.date"
              type="date"
              class="form-control"
              :class="{'is-invalid': showError && !checkRequest.date}"
              :max="getCurrentDate()"
              placeholder="Selecione a data"
              @click="$event.target.showPicker()"
            >
          </div>
          <div class="col-md-4">
            <label><span class="required">*</span> Hora</label>
            <input
              v-model="checkRequest.time"
              type="time"
              class="form-control"
              :class="{'is-invalid': showError && !checkRequest.time}"
              placeholder="Hora"
              @click="$event.target.showPicker()"
            >
          </div>
          <div class="col-md-4">
            <label>Anexo</label>
            <input
              id="file"
              type="file"
              class="form-control"
            >
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-12">
            <label><span class="required">*</span> Justificativa</label>
            <textarea
              v-model="checkRequest.justification"
              rows="5"
              class="form-control"
              :class="{'is-invalid': showError && !checkRequest.justification}"
            />
          </div>
        </div>
        <div class="block text-right mb-1">
          <router-link
            to="/checkRequests"
            class="btn btn-back"
          >
            <i class="fa fa-arrow-left" /> Voltar
          </router-link>
          <a
            class="btn btn-add ml-1"
            @click="save"
          >
            Salvar
            <i class="fa fa-save" />
          </a>
        </div>
        <div class="row">
          <div class="col-md-4">
            <p><span class="required">*</span> Campos Obrigatórios</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      checkRequest: {
        date: '',
        time: '',
        justification: '',
      },
      showError: false,
    }
  },
  computed: {
    datetime() {
      if (this.checkRequest.date && this.checkRequest.time) {
        return `${this.checkRequest.date} ${this.checkRequest.time}:00`
      }
      return ''
    },
  },
  mounted() {
    const { id } = this.$route.params
    if (id) {
      this.getCheckRequest(id)
    }
  },
  methods: {
    validateDateTime() {
      this.showError = true
      if (!this.checkRequest.date || !this.checkRequest.time) {
        this.$message('Erro', 'Data e hora são obrigatórios', 'error')
        return false
      }

      const requestDateTime = moment(
        `${this.checkRequest.date} ${this.checkRequest.time}`,
        'YYYY-MM-DD HH:mm',
      )
      const currentDateTime = moment()

      if (requestDateTime.isAfter(currentDateTime)) {
        this.$message(
          'Erro',
          'Não é possível criar solicitação para data e hora futura. Selecione uma data igual ou anterior à data atual.',
          'error',
        )
        return false
      }

      return true
    },

    save() {
      this.showError = true
      if (!this.checkRequest.date || !this.checkRequest.time || !this.checkRequest.justification) {
        this.$message('Erro', 'Preencha todos os campos obrigatórios', 'error')
        return
      }
      if (!this.validateDateTime()) {
        return
      }

      if (this.checkRequest.id) return this.edit()

      const api = `${this.$store.state.api}checkrequests`

      const fd = this.makeFormData()
      if (!fd) return

      axios
        .post(api, fd)
        .then(response => {
          this.$message(
            'Sucesso',
            'Solicitação de marcação cadastrada com sucesso',
            'success',
          )
          this.$router.push('/checkRequests')
        })
        .catch(error => {
          this.$message(null, error.response.data, 'error')
        })
    },
    edit() {
      this.showError = true
      if (!this.checkRequest.date || !this.checkRequest.time || !this.checkRequest.justification) {
        this.$message('Erro', 'Preencha todos os campos obrigatórios', 'error')
        return
      }
      if (!this.validateDateTime()) {
        return
      }

      const api = `${this.$store.state.api}checkrequests/${this.checkRequest.id}`

      const fd = this.makeFormData()
      if (!fd) return

      axios
        .post(api, fd)
        .then(response => {
          this.$message(
            'Sucesso',
            'Solicitação de marcação editada com sucesso',
            'success',
          )
          this.$router.push('/checkRequests')
        })
        .catch(error => {
          this.$message(null, error.response.data, 'error')
        })
    },
    makeFormData() {
      const fd = new FormData()

      fd.append('datetime', this.datetime)
      fd.append('justification', this.checkRequest.justification)

      const file = document.getElementById('file').files[0]
      if (file) {
        fd.append('file', file)
      }

      if (this.checkRequest.id) {
        fd.append('id', this.checkRequest.id)
        fd.append('_method', 'PUT')
      }

      return fd
    },
    getCheckRequest(id) {
      const api = `${this.$store.state.api}checkrequests/${id}`

      axios
        .get(api)
        .then(response => {
          const data = response.data.data[0]
          this.checkRequest.justification = data.justification

          if (data.datetime) {
            const dateTime = moment(data.datetime, 'YYYY-MM-DD HH:mm:ss')
            this.checkRequest.date = dateTime.format('YYYY-MM-DD')
            this.checkRequest.time = dateTime.format('HH:mm')
          }

          this.checkRequest.id = data.id
        })
        .catch(error => {
          this.errors = error.response.data
          this.$message(null, this.errors, 'error')
        })
    },
    getCurrentDate() {
      return moment().format('YYYY-MM-DD')
    },
  },
}
</script>

<style>
@media screen and (max-width: 480px) {
  .vdatetime-popup {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    width: 280px !important;
    max-width: 280px !important;
    min-width: 280px !important;
    height: 350px !important;
    max-height: 350px !important;
    min-height: auto !important;
    margin: 0 !important;
    border-radius: 8px !important;
    overflow: hidden !important;
    z-index: 10000 !important;
  }

  .vdatetime-overlay {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    background: rgba(0, 0, 0, 0.5) !important;
    z-index: 9999 !important;
  }
}

@media screen and (max-width: 600px) {
  .vdatetime-popup {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    width: 300px !important;
    max-width: 300px !important;
    min-width: 300px !important;
    height: 380px !important;
    max-height: 380px !important;
    min-height: auto !important;
    margin: 0 !important;
    border-radius: 8px !important;
    overflow: hidden !important;
    z-index: 10000 !important;
  }

  .vdatetime-overlay {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    background: rgba(0, 0, 0, 0.5) !important;
    z-index: 9999 !important;
  }
}

@media screen and (max-width: 767px) {
  .vdatetime-popup {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    width: 320px !important;
    max-width: 320px !important;
    min-width: 320px !important;
    height: 400px !important;
    max-height: 400px !important;
    min-height: auto !important;
    margin: 0 !important;
    border-radius: 8px !important;
    overflow: hidden !important;
    z-index: 10000 !important;
  }

  .vdatetime-overlay {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    background: rgba(0, 0, 0, 0.5) !important;
    z-index: 9999 !important;
  }

  .vdatetime-popup__header {
    padding: 0.5rem !important;
    font-size: 0.9rem !important;
    height: 45px !important;
    min-height: 45px !important;
  }

  .vdatetime-popup__body {
    padding: 0.5rem !important;
    height: calc(100% - 90px) !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
  }

  .vdatetime-popup__actions {
    padding: 0.5rem !important;
    height: 45px !important;
    min-height: 45px !important;
  }

  .vdatetime-calendar__month__day {
    width: 30px !important;
    height: 30px !important;
    font-size: 0.8rem !important;
    line-height: 30px !important;
    margin: 1px !important;
  }

  .vdatetime-calendar__month__weekday {
    width: 30px !important;
    height: 25px !important;
    font-size: 0.7rem !important;
    line-height: 25px !important;
  }

  .vdatetime-time-picker {
    max-height: 150px !important;
  }

  .vdatetime-time-picker__item {
    font-size: 0.8rem !important;
    padding: 0.3rem !important;
    min-height: 30px !important;
  }

  .vdatetime-popup__actions__button {
    padding: 0.4rem 0.8rem !important;
    font-size: 0.8rem !important;
    min-height: 35px !important;
  }
}
</style>

<style scoped>
@media (max-width: 767.98px) {
  .form-control {
    font-size: 0.9rem !important;
  }
  ::v-deep .vdatetime-popup {
    max-width: 400px !important;
    max-height: 500px !important;
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) scale(0.95) !important;
  }
}

.required {
  color: #dc3545;
  font-weight: bold;
}
</style>
